import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useEffect, useState } from 'react';
import { PageSetupSettings } from './PageSetupSettings';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { FormatSettings } from './FormatSettings';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { EditorDefaultSidePanelType, selectActiveSidePanel } from 'components/editor/grid/reduxStore/blockStyleSettingsSlice';
import { ContentType } from 'utils/getContentType';
import { selectContentType } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { SectionPageSetupSettings } from '../../SectionSettings/SectionPageSetupSettings';

export function DesignSettingsPanel() {
  const { t } = useTranslation();
  const contentType = useAppSelector(selectContentType);
  const activeSidePanel = useAppSelector(selectActiveSidePanel);
  const [value, setValue] = useState('page_setup_settings');

  useEffect(() => {
    if (activeSidePanel === EditorDefaultSidePanelType.FORMAT_SETTINGS_PANEL) {
      setValue('format_settings');
    }
  }, [activeSidePanel]);

  return (
    <>
      <Tabs value={value} onChange={(_, newValue) => setValue(newValue)} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Tab
          value="page_setup_settings"
          label={
            <Typography variant="body2" fontWeight={600} textTransform="none">
              {t('editor.nav_tab.page_setup')}
            </Typography>
          }
        />
        <Tab
          value="format_settings"
          label={
            <Typography variant="body2" fontWeight={600} textTransform="none">
              {t('editor.nav_tab.format')}
            </Typography>
          }
        />
      </Tabs>
      {value === 'page_setup_settings' && contentType === ContentType.SECTION ? (
        <SectionPageSetupSettings />
      ) : (
        value === 'page_setup_settings' && <PageSetupSettings />
      )}
      {value === 'format_settings' && <FormatSettings />}
    </>
  );
}
